import { trackCustomerIOEvent } from "@/services/customerio";

const trackCustomerIOAnalytics = (
  eventName: string,
  data: Record<string, unknown> = {},
) => {
  trackCustomerIOEvent(eventName, data);
};

export default trackCustomerIOAnalytics;
